type Props = {
  title: string;
  body: string;
};

const FullpageCta: React.FC<Props> = ({ body, title }) => {
  return (
    <section className="flex flex-col items-center justify-center py-24 md:py-48">
      <h2 className="text-center font-bold">{title}</h2>
      <p className="mb-4 text-center">{body}</p>
    </section>
  );
};

export default FullpageCta;
